// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K-Y9","field":"styles_field__1iH8I","fieldCol":"styles_fieldCol__1nPg3","diffCol":"styles_diffCol__K1P-p","diff":"styles_diff__3UIum"};